import { Injectable } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { RoutingService, UrlCommands } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomRoutingService extends RoutingService {
  // protected override store = inject(Store<RouterState>);
  // protected override winRef = inject(WindowRef);
  // protected override semanticPathService = inject(SemanticPathService);
  // protected override routingParamsService = inject(RoutingParamsService);
  // protected override router = inject(Router);
  // protected override location = inject(Location);

  override getFullUrl(commands: UrlCommands, extras?: NavigationExtras) {
    return `${this.winRef.location.origin}${this.getUrl(commands, extras)}`;
  }
}
